module.exports = __webpack_public_path__ + "img/cancun-bay-resort.598edd58.jpg";